export default "__VITE_ASSET__DtpXjymk__"